import styled, { css } from 'styled-components';

import { type ActivityStatusTypes } from '@app/client';

export const Wrapper = styled.div<{ $status: ActivityStatusTypes }>`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: -0.02em;

    display: flex;
    align-items: center;
    justify-self: end;

    border-radius: 100px;

    height: 22px;
    padding: 0 10px;

    ${({ $status }) => {
        if ($status === 'listed')
            return css`
                color: #ff8a34;
                border: 1px solid rgba(255, 147, 69, 0.2);
            `;
        if ($status === 'bid')
            return css`
                color: #62dffa;
                border: 1px solid rgba(98, 223, 250, 0.2);
            `;
        if ($status === 'transfer')
            return css`
                color: #e334ff;
                border: 1px solid rgba(227, 52, 255, 0.2);
            `;

        if ($status === 'sale')
            return css`
                color: #ee0a4a;
                border: 1px solid rgba(255, 0, 0, 0.2);
            `;

        if ($status === 'buy')
            return css`
                color: #62fa71;
                border: 1px solid rgba(98, 250, 113, 0.1);
            `;

        if ($status === 'mint')
            return css`
                color: #9362fa;
                border: 1px solid rgba(201, 98, 250, 0.2);
            `;

        if ($status === 'offer')
            return css`
                color: #62fa71;
                border: 1px solid rgba(98, 250, 113, 0.1);
            `;

        if ($status === 'burn')
            return css`
                color: #ee0a4a;
                border: 1px solid rgba(255, 0, 0, 0.2);
            `;
    }}

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 12px;
        height: 24px;
    }
`;
